// extracted by mini-css-extract-plugin
export default {"wrapper":"kAnCb","iconWrapper":"Q1eRY","icon":"EUcQi","format":"izdHt","text":"bT0eV","info":"WYGms"};